import get from 'lodash/get';

export const Queue = data => ({
  id: data.id,
  type: data.type,
  name: data.name,
  enteredAt: data.enteredAt,
  estimatedWaitTime: data.estimatedWaitTime,
  latestWaitTime: data.latestWaitTime,
  sessionId: data.sessionId,
});

export const responseToQueue = response => {
  const responseData = get(response, 'data');
  return new Queue({
    id: get(responseData, 'data.id'),
    type: get(responseData, 'data.type'),
    name: get(responseData, 'data.attributes.name'),
    enteredAt: get(responseData, 'data.attributes.enteredAt'),
    estimatedWaitTime: get(responseData, 'data.attributes.estimatedWaitTimeSeconds'),
    latestWaitTime: get(responseData, 'data.attributes.latestWaitTimeSeconds'),
    sessionId: get(responseData, 'data.relationships.session.data.id'),
  });
};
